import { createContext } from 'react'

export interface WorkingDocumentContextType {
  isWorkingDocumentExcluded: boolean
  setIsWorkingDocumentExcluded: (value: boolean) => void
}

export const WorkingDocumentContext = createContext<WorkingDocumentContextType | undefined>(
  undefined
)
